// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__20Wzn","description":"PatientConsentPreview_description__2447c"};